export default function certificate() {
    if (!document.querySelector('.giftcards')) return

    const faqItems = document.querySelectorAll('.certificate-faq__item')

    faqItems.forEach(item => {
        item.addEventListener('click', () => {        
            faqItems.forEach(item2 => {
                if (item != item2 || item.classList.contains('active')) {
                    item2.classList.remove('active')
                    item2.querySelector('.certificate-faq__item-inner').style.height = `0px`
                } else {
                    item.classList.add('active')
                    const inner = item.querySelector('.certificate-faq__item-inner')
                    inner.style.height = `${inner.scrollHeight}px`
                }
            })
        })
    })

    const tabs = document.querySelectorAll('.certificate-variants__tab')
    const tabBlock = document.querySelector('.certificate-variants__desc-inner')

    tabBlock.innerHTML = tabs[0].querySelector('.certificate-variants__tab-text').innerHTML

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            if (window.innerWidth > 1024) {
                tabBlock.innerHTML = tab.querySelector('.certificate-variants__tab-text').innerHTML
            } else {
                tabs.forEach(tab2 => {
                    if (tab != tab2 || tab.classList.contains('active')) {
                        tab2.classList.remove('active')
                        tab2.querySelector('.certificate-variants__tab-inner').style.height = `0px`
                    } else {
                        tab.classList.add('active')
                        const inner = tab.querySelector('.certificate-variants__tab-inner')
                        inner.style.height = `${inner.scrollHeight}px`
                    }
                })
            }
        })
    })
}
